Flow.set('on', 'ready', () => {
  function getUrlParameters(searchData) {
    let search = searchData || window.location.search;
    if (search.indexOf('?') === 0) {
      search = search.slice(1);
    }

    return search.split('&').reduce((result, keyVal) => {
      const parts = keyVal.split('=');
      result[parts[0]] = parts[1];
      return result;
    }, {});
  }

  function toQueryString(data) {
    const keys = Object.keys(data);
    return keys.map(key => `${key}=${encodeURIComponent(data[key])}`).join('&');
  }

  function getSession() {
    return JSON.parse(localStorage.getItem('_f60_session'));
  }


  const urlParameters = getUrlParameters();

  if (urlParameters.flow_order) {
    const orderDataString = decodeURIComponent(urlParameters.flow_order);
    const orderData = getUrlParameters(orderDataString);
    const session = getSession();
  
    if (session) {
      orderData.experience = session.experience.key;
      const checkoutRedirect = `/apps/flow/${session.organization}/order?${toQueryString(orderData)}`;

      document.location.replace(checkoutRedirect);
    }
  }
});